export default __webpack_public_path__ + "static/media/linkedIn.05ad1948.svg";